import React from "react";
import Header from "./Components/Header/Header";
import Topbar from "./Components/Topbar/Topbar";
import Herosection from "./Components/Section/Herosection";
import Footer from "./Components/Footer/Footer";
import CardContainer from "./Components/Card/CardContainer";
import Slider from "./Components/Slider/Slider";
import SearchAppBar from "./Components/Bar/Bar";


function App() {
  return (
   <>
     <Topbar />
     <SearchAppBar/>
     <Header />
     <Slider></Slider>
     <Herosection/>
     <CardContainer/>
     <Footer/>
   </>
  );
}

export default App;
